import { ReactNode } from "react";
import { Link } from "react-router-dom";
import Spinner from "../../ui/sppinner/Spinner";
import "./CommonButton.scss";

const CommonButton = ({
  title,
  className,
  svgIcon,
  imgicon,
  onClick,
  to,
  role,
  type,
  disabled,
  isLoading,
  fluid,
  text,
  children,
  ref,
  value,
  name,
}: {
  title?: string;
  className?: string;
  svgIcon?: ReactNode;
  imgicon?: string;
  onClick?: any;
  to?: any;
  id?: string;
  role?: string;
  type?: "button" | "submit" | "reset";
  disabled?: boolean;
  isLoading?: boolean;
  fluid?: boolean;
  text?: string;
  children?: ReactNode;
  ref?: any;
  value?: any;
  name?: any;
}) => {
  return (
    <>
      {(() => {
        switch (role) {
          case "link":
            return (
              <Link
                to={to}
                className={`common_btn ${fluid ? "full" : ""} ${className}`}
                ref={ref}
                onClick={onClick}
              >
                {title && <span className="common_btn_title">{title}</span>}
                {svgIcon && (
                  <>
                    <span className="common_btn_icon">{svgIcon}</span>
                  </>
                )}
                {imgicon && (
                  <>
                    <span className="common_btn_icon">
                      <img
                        src={imgicon}
                        alt="" 
                      />
                    </span>
                  </>
                )}
                {isLoading ? <Spinner /> : text}
                {children}
              </Link>
            );
          default:
            return (
              <button
                value={value}
                name={name}
                className={`common_btn ${fluid ? "full" : ""} ${className}`}
                onClick={onClick}
                disabled={disabled}
                type={type ? type : "button"}
                ref={ref}
              >
                {title && <span className="common_btn_title">{title}</span>}
                {svgIcon && (
                  <>
                    <span className="common_btn_icon">{svgIcon}</span>
                  </>
                )}
                {imgicon && (
                  <>
                    <span className="common_btn_icon">
                      <img
                        src={imgicon}
                        alt="" 
                      />
                    </span>
                  </>
                )}
                {/* {
                    loader && <Loader />
                  } */}
                {isLoading ? <Spinner /> : text}
                {children}
              </button>
            );
        }
      })()}
    </>
  );
};

export default CommonButton;
